import type { CSSProperties } from 'react';

interface AiAgentIconProps {
  size?: number;
  className?: string;
  style?: CSSProperties;
  animated?: boolean;
}

export function AiAgentIcon({ size = 18, className, style, animated }: AiAgentIconProps) {
  return (
    <>
      <style>{`
        @keyframes aiAgentGradientFlow {
          0% {
            color: rgb(0, 125, 217);
          }
          25% {
            color: rgb(0, 217, 125);
          }
          50% {
            color: rgb(217, 0, 125);
          }
          75% {
            color: rgb(125, 0, 217);
          }
          100% {
            color: rgb(0, 125, 217);
          }
        }

        .ai-agent-icon-animated {
          animation: aiAgentGradientFlow 3s ease-in-out infinite;
        }
      `}</style>
      <svg
        className={animated ? `${className || ''} ai-agent-icon-animated` : className}
        width={size}
        height={size}
        viewBox="0 0 200 200"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: 'inline-block', ...style }}
        role="img"
        aria-hidden="true"
      >
        <path
          d="M0 0 C0.81 0.04 1.61 0.07 2.45 0.11 C7.38 0.38 11.68 1.15 16.38 2.69 C14.45 14.21 14.45 14.21 12.38 19.69 C10.93 19.45 10.93 19.45 9.46 19.21 C-9.57 16.53 -27.82 19.37 -43.62 30.69 C-56.82 40.86 -66.61 55.22 -69.39 71.85 C-71.24 86.51 -69.43 100.29 -62.81 113.5 C-58.09 123.44 -62.93 134.6 -65.62 144.69 C-64.59 144.41 -63.55 144.13 -62.48 143.85 C-58.21 142.73 -53.92 141.7 -49.62 140.69 C-48.22 140.34 -48.22 140.34 -46.79 139.99 C-40.87 138.92 -36.85 140.66 -31.64 143.28 C-18.03 150.08 -0.97 150.99 13.58 146.66 C14.5 146.34 15.43 146.02 16.38 145.69 C17.37 145.35 18.36 145.01 19.39 144.66 C36.41 138.2 47.92 126.07 55.7 109.94 C56.7 107.55 57.58 105.16 58.38 102.69 C58.59 102.03 58.8 101.38 59.02 100.7 C60.69 94.51 60.78 88.1 61.03 81.72 C61.07 80.96 61.1 80.19 61.13 79.41 C61.15 78.71 61.18 78.02 61.2 77.31 C61.38 75.69 61.38 75.69 62.38 74.69 C63.57 74.53 64.77 74.44 65.97 74.37 C66.69 74.33 67.41 74.29 68.15 74.24 C68.91 74.2 69.66 74.17 70.44 74.12 C71.2 74.08 71.95 74.04 72.74 73.99 C74.62 73.89 76.5 73.79 78.38 73.69 C81.9 94.37 75.73 115.18 63.98 132.27 C50.9 150.38 31.52 162.9 9.38 166.69 C-7.6 168.91 -23.06 167.22 -38.74 160.32 C-44.97 158.22 -49.68 159.06 -55.89 160.56 C-56.77 160.76 -57.64 160.96 -58.54 161.17 C-61.32 161.81 -64.1 162.47 -66.88 163.12 C-69.67 163.78 -72.46 164.42 -75.25 165.07 C-76.99 165.47 -78.72 165.88 -80.45 166.29 C-81.63 166.56 -81.63 166.56 -82.82 166.85 C-83.51 167.01 -84.2 167.17 -84.91 167.34 C-86.62 167.69 -86.62 167.69 -88.62 167.69 C-88.07 164.81 -87.5 161.94 -86.94 159.06 C-86.76 158.18 -86.59 157.29 -86.41 156.37 C-85.43 151.45 -84.38 146.55 -83.21 141.67 C-82.98 140.69 -82.75 139.71 -82.51 138.71 C-82.05 136.81 -81.59 134.92 -81.11 133.02 C-78.98 124.13 -80.93 118.55 -84.37 110.2 C-91.66 91.02 -89.61 68.26 -81.62 49.69 C-71.64 28.66 -55.24 13.19 -33.6 4.71 C-22.45 0.87 -11.74 -0.69 0 0 Z"
          fill="currentColor"
          transform="translate(104.625,16.3125)"
        />
        <path
          d="M0 0 C2.35 -0.21 2.35 -0.21 5 0 C6.37 1.4 6.37 1.4 7.44 3.38 C7.85 4.1 8.27 4.83 8.69 5.58 C9.12 6.38 9.56 7.18 10 8 C16.59 19.97 24.11 24.95 36 31 C36.25 33.81 36.25 33.81 36 37 C33.25 39.85 29.53 41.33 26 43.06 C24.97 43.57 23.94 44.08 22.88 44.6 C21.19 45.42 19.48 46.21 17.75 46.93 C15.45 48.33 15.07 49.53 14 52 C13.37 53.15 12.74 54.28 12.09 55.42 C11.74 56.03 11.39 56.65 11.03 57.28 C10.67 57.91 10.31 58.54 9.94 59.19 C9.57 59.83 9.21 60.47 8.83 61.13 C8.49 61.74 8.14 62.35 7.78 62.98 C7.46 63.54 7.14 64.09 6.82 64.66 C6 66 6 66 5 67 C2.62 67.31 2.62 67.31 0 67 C-2.41 64.28 -3.87 61.35 -5.38 58.06 C-7.47 53.79 -9.39 51.07 -13 48 C-13.75 47.36 -14.5 46.71 -15.27 46.05 C-19.03 43.23 -23.14 41.6 -27.45 39.76 C-30 38 -30 38 -30.86 34.8 C-30.93 33.42 -30.93 33.42 -31 32 C-30.53 31.71 -30.05 31.42 -29.57 31.12 C-24.96 28.26 -20.45 25.3 -15.98 22.23 C-14 21 -14 21 -11 20 C-9.89 18.16 -9.89 18.16 -9 16 C-8.29 14.7 -7.57 13.4 -6.84 12.11 C-6.24 11.05 -6.24 11.05 -5.62 9.96 C-5.21 9.23 -4.8 8.5 -4.38 7.75 C-3.95 7 -3.53 6.26 -3.1 5.49 C-2.07 3.66 -1.03 1.83 0 0 Z"
          fill="currentColor"
          transform="translate(164,8)"
        />
        <path
          d="M0 0 C5.61 0 11.22 0 17 0 C17.41 1.34 17.83 2.68 18.25 4.06 C19.51 7.89 21.08 11.19 23.23 14.59 C24 16 24 16 24 18 C24.7 18.27 25.4 18.54 26.12 18.81 C29 20 29 20 31.81 21.56 C37.67 24.2 42.87 24.51 49.04 22.75 C51.74 21.72 54.13 20.35 56.55 18.8 C58 18 58 18 60 18 C60.27 17.3 60.54 16.6 60.81 15.88 C62 13 62 13 63.5 10.12 C65.37 6.46 65.37 6.46 67 0 C72.61 0 78.22 0 84 0 C83.51 12.35 80.17 21.84 71.45 30.81 C62.54 38.79 51.57 42.73 39.57 42.29 C31.11 41.35 23.78 39.21 17 34 C16.32 33.5 15.64 32.99 14.95 32.47 C6.01 25.31 1.81 16.19 0 5 C0 3.35 0 1.7 0 0 Z"
          fill="currentColor"
          transform="translate(58,100)"
        />
      </svg>
    </>
  );
}
